import { render, staticRenderFns } from "./SalespersonModal.vue?vue&type=template&id=2c894898&scoped=true&lang=pug&"
import script from "./SalespersonModal.vue?vue&type=script&lang=js&"
export * from "./SalespersonModal.vue?vue&type=script&lang=js&"
import style0 from "./SalespersonModal.vue?vue&type=style&index=0&id=2c894898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c894898",
  null
  
)

component.options.__file = "SalespersonModal.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VContainer,
  VDialog,
  VFlex,
  VForm,
  VLayout,
  VTextField,
  VToolbar,
})
